import axios from 'axios';
import showToaster from '../showToaster';
import { getShortPushNotification } from './getShortPushNotification';

export async function sendNotifications(type, requestContent, userId, userType) {

    let content = {};

    if (type !== 'notification') {
        content = requestContent;
        let message = content.message
        const trimContent = await getShortPushNotification(message);
        content['message'] = trimContent || message;
    } else {
        content = requestContent;
    }

    const response = await axios.post(`/push-notification`, {
        content,
        userId,
        userType
    }, {
        headers: {
            Accept: 'application/json',
            'Content-Type': 'application/json'
        },
        withCredentials: true
    });

    const { status, errorMessage } = await response && response.data;

    showToaster({ messageId: 'sendNotification', toasterType: 'success' })

    return await {
        status,
        errorMessage
    };
}

export default {
    sendNotifications
}
